import { getAuth, signOut } from 'firebase/auth';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearExternalAuthId } from './oauthConnect';

export default function SignOut() {
  const auth = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleSignOut = async () => {
      // A pending AI-app connection belongs to the person who started it; never carry it to the next sign-in.
      clearExternalAuthId();
      try {
        await signOut(auth);
        navigate('/sign-in');
      } catch (error) {
        console.error('Error signing out:', error);
        navigate('/profile'); // Return to profile on error
      }
    };

    handleSignOut();
  }, [navigate, auth]);

  return null; // This component doesn't render anything
}
